import type { DealRefreshModalState } from './types';

export const initialState: DealRefreshModalState = {
    isVisible: false
};
